import { css } from '@/styled-system/css';

export const cluster = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 'tighter',
  flexShrink: 0,
  minWidth: '1800',
});

export const authButton = css({
  whiteSpace: 'nowrap',
  borderRadius: 'pill!',
});

export const authPlaceholder = css({
  display: 'inline-flex',
  alignItems: 'center',
  width: '1800',
  height: '800',
});

export const authPlaceholderSkeleton = css({
  width: 'full',
  height: 'full',
  borderRadius: 'pill',
});

export const identityLabelStack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '50',
  minWidth: 0,
});

export const identityName = css({
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
  lineHeight: 'sm',
});

export const identitySubtitle = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  lineHeight: 'sm',
});
